import React, { useEffect, useState } from 'react';
import { ImageType } from 'react-images-uploading';
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
  InputText,
  InputTextType
} from '../../../../shared/components/core-ui/input-text/input-text.component';
import ImageUploader from '../../../../shared/components/core-ui/image-uploader/image-uploader.component';
import Button, { ButtonSize } from '../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../shared/hooks/window-resizer/window-resizer.hook';
import { FormElementData } from '../../../../shared/interfaces/form-element-data.interface';
import { BlogUiModel } from '../../../../shared/ui-models/blog.ui-model';
import { BLOG_IMAGE_ASPECT_RATIO } from '../../../shared/config/blog-module.config';
import { EditBlogContentProps } from './edit-blog-content.container';

/**
 * functional component EditBlogContentArabic — the Arabic side of a blog post
 */
export const EditBlogContentArabic: React.FC<EditBlogContentProps> = ({
  data,
  config,
  eventHandlers
}) => {
  const isMobileView = useWindowResizer();

  const [newHeaderAr, setNewHeaderAr] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newBodyAr, setNewBodyAr] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });

  useEffect(() => {
    setNewHeaderAr({ value: data.blog?.headerAr || '', isValid: false, changed: false });
    setNewBodyAr({ value: data.blog?.bodyAr || '', isValid: false, changed: false });
  }, [data.blog]);

  const handleSubmit = () => {
    const updatedData: Partial<BlogUiModel> = {};

    if (newHeaderAr.changed) {
      updatedData.headerAr = newHeaderAr.value;
    }
    if (newBodyAr.changed) {
      updatedData.bodyAr = newBodyAr.value;
    }

    eventHandlers.submitHandler(updatedData);
  };

  const isSubmitDisabled = config.isLoading || (!newHeaderAr.changed && !newBodyAr.changed);

  return (
    <div className="flex w-full flex-col gap-[1.5rem] text-right" style={{ direction: 'rtl' }}>
      <div className="text-[1.8rem] font-bold text-primary-500">المحتوى بالعربية</div>

      <div className="flex w-full flex-col gap-[0.5rem]">
        <div className="font-medium">العنوان</div>
        <InputText
          config={{
            autoFocus: false,
            type: InputTextType.text,
            required: true,
            disabled: config.isLoading
          }}
          data={{
            placeholder: 'عنوان المقال',
            errorMessage: 'العنوان مطلوب',
            value: newHeaderAr.value || ''
          }}
          eventHandlers={{
            onChangeHandler: (value, isValid) => {
              setNewHeaderAr({ value, isValid, changed: true });
              eventHandlers.valuesChangeHandler({ headerAr: value });
            }
          }}
        />
      </div>

      <div className="flex w-full flex-col gap-[0.5rem]">
        <div className="font-medium">الصورة</div>
        <div style={{ direction: 'ltr' }}>
          <ImageUploader
            data={{ imageUrl: data.blog?.imageAr }}
            config={{ enableCrop: true, cropAspectRatio: BLOG_IMAGE_ASPECT_RATIO }}
            eventHandlers={{
              fileUploadHandler: (file: ImageType) => {
                eventHandlers.imageUploadHandler(file);
              },
              imageRemovedHandler: () => {
                return;
              }
            }}
          />
        </div>
      </div>

      {newBodyAr.value !== undefined && (
        <div className="flex w-full flex-col gap-[0.5rem]">
          <div className="font-medium">نص المقال</div>
          <CKEditor
            editor={ClassicEditor}
            data={newBodyAr.value}
            onChange={(_event: any, editor: any) => {
              const editorData: string = editor.getData();
              setNewBodyAr({ value: editorData, isValid: true, changed: true });
              eventHandlers.valuesChangeHandler({ bodyAr: editorData });
            }}
          />
        </div>
      )}

      <div className="flex w-full justify-end" style={{ direction: 'rtl' }}>
        <Button
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
        >
          {config.isNew ? 'إنشاء' : 'حفظ'}
        </Button>
      </div>
    </div>
  );
};

export default EditBlogContentArabic;
